export const environment = {};
export const backendServerUrl: string = 'https://dev.b-system.ideastream.io';
export const serverurl: string = 'https://dev.f-system.ideastream.io';
export const appurl: string = 'https://dev.app.ideastream.io';
export const smallDialogWidth: string = '400px';
export const allowedDomains: string[] = [
  'https://dev.f-system.ideastream.io',
  'ws://dev.app.ideastream.io',
];
export const inviteDisabled: boolean = true;
export const minimalFeedBacksForBMC: number = 30;
export const pathToClosingAssets = 'knowledgehub/generic-closing';

export const maxCharsForTextExtraction: number = 300000;
export const maxFileSizeInBite: number = 20000000; // 20 MB

export const onepageioBaseUrl: string =
  'https://ideastream.io/anmeldung-erstberatung';

export const LEGAL_AVV: string =
  'V1-0_2026_01_08_AVV_Auftragsverarbeitungsvertrag_IdeastreamGmbH.pdf';
export const LEGAL_TOMS: string = 'V1-0_2026_01_08_TOMS_IdeastreamGmbH.pdf';
export const LEGAL_TERMS_OF_CONDITIONS: string =
  'V1-0_2026_01_08_SaaS AGB_IdeastreamGmbH.pdf';
export const LEGAL_TERMS_OF_USE: string =
  'V1-0_2026_01_08_NUTZUNGSBEDINGUNGEN_IdeastreamGmbH.pdf';
export const LEGAL_PRIVACY_POLICY: string =
  'V1-0_2026_01_08_DATENSCHUTZ_IdeastreamGmbH.pdf';
export const LEGAL_IMPRINT: string = 'imprint';
